export const ProductVersion: {
  M3: string;
  M3_QUICK_APPROVAL: string;
  M3_SELF_ONBOARDING: string;
  M3_ECOMMERCE: string;
  SHRINK_WRAP: string;
} = {
  M3: "M3",
  M3_QUICK_APPROVAL: "M3_QUICK_APPROVAL",
  M3_SELF_ONBOARDING: "M3_SELF_ONBOARDING",
  M3_ECOMMERCE: "M3_ECOMMERCE",
  SHRINK_WRAP: "SHRINK_WRAP",
};
